import React from 'react';
import { withTranslation } from 'react-i18next';
import LogoIcon from '../../../assets/images/logo/regiom-logo-black.svg';
import FacebookIcon from '../../../assets/images/socialIcons/facebook.svg';
import PinterestIcon from '../../../assets/images/socialIcons/pinterest.svg';
import TwitterIcon from '../../../assets/images/socialIcons/twitter.svg';
import InstagramIcon from '../../../assets/images/socialIcons/instagram.svg';

class FooterBar extends React.Component {
  render() {
    const { t } = this.props;
    return (
      <div className="columns is-gapless footer-bar" style={{position: "relative"}}>
        <div className="column">
          <div style={{marginTop: "10px", marginBottom: "10px"}}>
            <img src={LogoIcon} style={{maxHeight: "20px"}} />
          </div>
          <div>Copyright (c) 2019 edv &amp; cad group</div>
        </div>
        <div className="column"></div>
        <div className="column">
          <div className="socials">
            <a>
              <img src={FacebookIcon} />
            </a>
            <a>
              <img src={TwitterIcon} />
            </a>
            <a>
              <img src={PinterestIcon} />
            </a>
            <a>
              <img src={InstagramIcon} />
            </a>
          </div>
        </div>
        <div className="column"></div>
        <div className="column">
          <div className="bold-text">{ t("call_us_today") }</div>
          <div className="bold-text">+49 (0) 8025/995969</div>
          <div>Mon - Thurs: 8am - 7pm ET</div>
          <div>Fri: 8am - 5pm ET</div>
        </div>
      </div>
    );
  }
}

export default (withTranslation()(FooterBar));
